import stylesheet from './Overlay.scss?inline';

import CustomComponent from "../../base/customComponent/CustomComponent";
import {OverlayInterface} from "./OverlayInterface";

export class NXTOverlay extends CustomComponent implements OverlayInterface {

    private _isOpen = false;
    private container: HTMLElement;

    constructor() {
        super();
        this.customStyle = stylesheet;
    }

    get isOpen(): boolean {
        return this._isOpen;
    }

    get footerLayout(): string {
        return this.getAttribute('footer-layout') ?? '';
    }

    get hasHeaderDivider(): boolean {
        return this.hasAttribute('header-divider');
    }

    get labelClose(): string {
        return this.getAttribute('label-close') ?? 'Close';
    }

    get backgroundColor(): string {
        return this.getAttribute('background') ?? 'light-gray';
    }

    open(): void {
        this.container.classList.add('open');
        document.querySelector('body').style.setProperty('overflow', 'hidden');
        document.querySelector('html').style.setProperty('overflow', 'hidden');
        this._isOpen = true;
    }

    close(): void {
        this.container.classList.remove('open');
        document.querySelector('body').style.removeProperty('overflow');
        document.querySelector('html').style.removeProperty('overflow');
        this._isOpen = false;
        this.dispatchEvent(new CustomEvent('pause3QPlayers', {
            bubbles: true,
        }));
    }

    render() {
        const container = document.createElement('div');
        this.container = container;
        container.classList.add(
            'overlay-container',
        );
        if (this.footerLayout === 'fill') {
            container.classList.add('footer-fill');
        }
        if (this.hasHeaderDivider) {
            container.classList.add('header-divider');
        }
        if (this.getAttribute('open') === 'true') {
            this.open();
        }
        container.innerHTML = `
            <div class="toggle"></div>
            <div class="page-backdrop"></div>
            <div class="overlay-content bg-${this.backgroundColor}">
                <header>
                    <div class="heading"></div>
                    <nxt-button type="link-secondary" class="close-button" icon-only size="icon" aria-label="${this.labelClose}">
                        <nxt-icon icon="close"></nxt-icon>
                    </nxt-button>
                </header>
                <div class="main"></div>
                <footer></footer>
            </div>
        `;
        container.querySelector('.close-button').addEventListener('click', (ev) => {
            ev.stopPropagation();
            this.close();
        })
        container.querySelector('.toggle').append(...this.renderToggle());
        container.querySelector('.overlay-content > header > .heading').append(...this.renderHeader());
        container.querySelector('.overlay-content > .main').append(...this.renderMain());
        container.querySelector('.overlay-content > footer').append(...this.renderFooter());
        this.addEventListener('open-overlay', () => {
            this.open();
        });
        this.addEventListener('close-overlay', () => {
            this.close();
        });
        return container;
    }

    renderToggle(): HTMLElement[] {
        return this.getSlotElements('toggle');
    }

    renderHeader(): HTMLElement[] {
        const overlineSlot = document.createElement('slot');
        overlineSlot.name = 'overline';
        const headerSlot = document.createElement('slot');
        headerSlot.name = 'header';
        return [overlineSlot, headerSlot];
    }

    renderMain(): HTMLElement[] {
        const mainSlot = document.createElement('slot');
        return [mainSlot];
    }

    renderFooter(): HTMLElement[] {
        const slot = document.createElement('slot');
        slot.name = 'footer';
        return [slot];
    }

}

customElements.define('nxt-overlay', NXTOverlay);
